import { releaseNoteOptions } from "../../../../../consts";
import { selectReleaseNotesList } from "../../../../../state/selectors";
import { getState } from "../../../../../state/store";

const getReleaseNotes = (versions = []) => {
  const releaseNotesList = selectReleaseNotesList()(getState());

  let type = null;
  let data = null;
  let releaseNoteVersion = null;

  let releaseNotesToCombine = [];
  let mediaData = [];
  let thumbnailsData = [];

  versions?.forEach((version) => {
    const releaseNotes = releaseNotesList[version];
    if (releaseNotes) {
      const { releaseNotesType, localizations = [], media, thumbnails } = releaseNotes ?? {};

      const enLocalization = localizations?.find((item) => item?.language === "EN");
      const localization = enLocalization ?? localizations[0];

      if (releaseNotesToCombine !== null && localization && (type === releaseNotesType || !type)) {
        releaseNotesToCombine.push(localization);
        mediaData.push(...(media ?? []));
        thumbnailsData.push(...(thumbnails ?? []));
      } else {
        releaseNotesToCombine = null;
        mediaData = media ?? [];
        thumbnailsData = thumbnails ?? [];
      }

      if (localization) {
        data = localization;
      }

      type = releaseNotesType;
      releaseNoteVersion = version;
    }
  });

  if (releaseNotesToCombine?.length > 1) {
    data = combineReleaseNotes(releaseNotesToCombine, type);
  }

  if (type && data) {
    return {
      type,
      data,
      isCombined: releaseNotesToCombine?.length > 1,
      mediaData,
      thumbnailsData,
      version: releaseNoteVersion
    };
  }

  return null;
};

const combineReleaseNotes = (releaseNotesToCombine, releaseNotesType) => {
  let combined;
  let summary;
  const combinedFeatures = [];

  releaseNotesToCombine?.forEach((item) => {
    combinedFeatures.push(...item?.features);
    summary = item?.summary;
  });

  if (releaseNotesType === releaseNoteOptions.SIMPLE_LIST) {
    const lastImprovements = releaseNotesToCombine[releaseNotesToCombine?.length - 1]?.improvements;

    combined = {
      summary,
      features: combinedFeatures,
      improvements: lastImprovements
    };
  } else {
    combined = {
      summary,
      features: combinedFeatures
    };
  }

  return combined;
};

export const releaseNotesUtils = {
  getReleaseNotes
};
